import { Link, useMatches, type UIMatch } from 'react-router';
import { COMPANY_NAME } from '@shared/config';

type CrumbHandle = { crumb?: string | ((params: Record<string, string | undefined>) => string) };

export function Breadcrumb() {
  const matches = useMatches() as UIMatch<unknown, CrumbHandle>[];
  const crumbs = matches
    .filter((m) => m.handle?.crumb)
    .map((m) => ({ path: m.pathname, label: typeof m.handle.crumb === 'function' ? m.handle.crumb(m.params) : m.handle.crumb! }));
  return (
    <div id="breadcrumb-bar" aria-label="Breadcrumb">
      <span>{COMPANY_NAME}</span>
      {crumbs.map((c, i) => (
        <span key={c.path}>
          <span className="bc-sep">›</span>
          {i === crumbs.length - 1 ? <span className="bc-current">{c.label}</span> : <Link to={c.path}>{c.label}</Link>}
        </span>
      ))}
    </div>
  );
}
